module.exports = __webpack_public_path__ + "img/ic_print.c7a07270.svg";